import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';


@Component({
  selector: 'app-review-type-model',
  templateUrl: './review-type-model.component.html',
  styleUrl: './review-type-model.component.scss'
})
export class ReviewTypeModelComponent {

  reviewTypeForm: UntypedFormGroup;
  @Input() public Content: any;
  ProgramId: any[];
  programlist: any = [];
  tooltipValue: any;
  Typelist =  [
    { label: 'Reviewer', value: 1 },
    { label: 'Approver', value: 2 }
  ];


  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) { }

  ngOnInit() 
  {
    this.reviewTypeForm = new UntypedFormGroup(
      {
          ID: new UntypedFormControl(""),
          NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
          MODULE_ID: new UntypedFormControl("", [Validators.required]),
          DESCRIPTION: new UntypedFormControl(""),
          RECORD_STATE: new UntypedFormControl(true),
          MAPPED_PROG: new UntypedFormControl([]),
          TASK_TYPE: new UntypedFormControl()
      });
      this.GetMasterData() ;
      if (this.Content.heading == "View") 
      {
        this.GetEditData();
        this.reviewTypeForm.disable();
      }
      if (this.Content.heading == "Edit") 
      { 
        this.GetEditData();
      }
  }

  GetEditData(): void 
  {

    this.summaryService.getSummaryData('api/reviewtype/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
     // console.log('Data from backend:', summary);
      let programIds = [];
        if (summary["MappedProgram"] != undefined && summary["MappedProgram"] != null && summary["MappedProgram"] != "") {
          programIds = summary["MappedProgram"].split("|");
        }
      this.reviewTypeForm.patchValue({
        ID: summary["ID"],
        NAME: summary["NAME"],
        RECORD_STATE: summary["RECORD_STATE"] == 1 ? true : false,
        MODULE_ID: programIds,
        MAPPED_PROG: programIds,
        SUB_MODULE: summary["SUB_MODULE"],
        DESCRIPTION: summary["DESCRIPTION"],
        TASK_TYPE:summary["TASK_TYPE"] 
      });
      if (this.Content.heading == "View") 
      {
        this.reviewTypeForm.disable();
      }
      else if (this.Content.heading == "Edit")
      {
        this.reviewTypeForm.controls["MODULE_ID"].disable();
        this.reviewTypeForm.controls["TASK_TYPE"].disable();
      }             
    });

  }

  changeVal($event) {
    let selectedProg = this.reviewTypeForm.controls["MODULE_ID"].value;
    if (selectedProg != "" && selectedProg != undefined && selectedProg != null) {
      let programLabel = this.programlist.filter((item) => {
        return selectedProg.indexOf(item.value) > -1;
      })
      let labellist = [];
      programLabel.forEach((item) => {
        labellist.push(item.label);
      });
      this.tooltipValue = labellist.join(",");
    }
    else {
      this.tooltipValue = "";
    }

  }

  GetMasterData() 
  {
    this.summaryService.GetMasterScreenData("api/reviewtype/GetMasterScreenData?RecordID=" + this.Content.content.id).subscribe(summary => {
      this.programlist = summary["MasterData1"];
      this.programlist.forEach((item: any) => {
              if (item.IsActive == false)
                item["icon"] = "ieg_inactive_record";
            })
    });
  }
  

  save() 
  {
    if (this.validateControls()) 
    {
      var formData = this.reviewTypeForm.getRawValue();
      formData.NAME=formData.NAME==null?null:formData.NAME==undefined?undefined:formData.NAME.trim();
      formData.RECORD_STATE = this.reviewTypeForm.controls["RECORD_STATE"].value ? 1 : 0;
      formData.MAPPED_PROG = formData.MODULE_ID;
      formData.DESCRIPTION = formData.DESCRIPTION==null?null:formData.DESCRIPTION==undefined?undefined:formData.DESCRIPTION.trim();
      if (formData.MODULE_ID != null && formData.MODULE_ID != "" && formData.MODULE_ID != undefined && formData.MODULE_ID.length > 0) {
        let selectedids = formData.MAPPED_PROG.join(",");
        
        formData.MODULE_ID = selectedids;
      }
      else {
        formData.MAPPED_PROG = "";
      }

      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert('api/reviewtype/Insert', formData).subscribe(summary => {
          if (summary.Status == 0) {
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
            this.reviewTypeForm.controls["ID"].setValue(this.Content.content.id);
          }
          else {
            this.commonservice.ValidationBanner(summary.Message);
          }
        });
      }
      else
      {
        this.summaryService.Insert('api/reviewtype/Update', formData).subscribe(summary => 
        {
          if (summary.Status == 0)
          {
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
          }
          else 
          {
            this.commonservice.ValidationBanner(summary.Message);
          }
        });
      }
    }
  }

  validateControls(): boolean 
  {
    let isValid = true;
    let message = "";
    const formData = this.reviewTypeForm.getRawValue();

    if (formData.NAME === null || formData.NAME === ""||formData.NAME===undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name <br/>";
      isValid = false;
    }else if(formData.NAME !=null&&formData.NAME !=undefined &&formData.NAME.trim()==""){
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name <br/>";
      isValid = false;
    } 
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.MODULE_ID === null || formData.MODULE_ID === ""||formData.MODULE_ID===undefined) 
    {
      $("#MODULE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#MODULE_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Program <br/>";
      isValid = false;
    }
    else 
    {
      $("#MODULE_ID").addClass("ng-untouched ng-valid");
      $("#MODULE_ID").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.TASK_TYPE === null || formData.TASK_TYPE === ""||formData.TASK_TYPE===undefined || formData.TASK_TYPE.length ===0) 
    {
      $("#TASK_TYPE").addClass("ng-touched ng-invalid validate-error");
      $("#TASK_TYPE").removeClass("ng-untouched ng-valid");
      message += "Please select Type <br/>";
      isValid = false;
    }
    else 
    {
      $("#TASK_TYPE").addClass("ng-untouched ng-valid");
      $("#TASK_TYPE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonservice.ValidationBanner(message);
    return isValid;
  }

}



